export const TIPO_TRANSFERENCIA_CONTA_BANCO_CAIXA_ENUM = [
    {
        id: 'BANCO_PARA_CAIXA',
        descricao: "Banco para Caixa",
    },
    {
        id: 'CAIXA_PARA_BANCO',
        descricao: "Caixa para Banco",
    },
];